var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":_vm.transition}},[(_vm.component)?_c('aside',_vm._b({staticClass:"MuiFullScreen"},'aside',_vm.attrs,false),[_c(_vm.component,_vm._g(_vm._b({tag:"Component"},'Component',_vm.props,false),_vm.listeners))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }